import { takeLatest, call, put, all, select } from 'redux-saga/effects';
// SERVICES
import { ApiResponse, postApi } from 'services/rotasp/api';
import { PATH_IIRGD_BU_PPT } from 'services/rotasp/path';

// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { DisponibilzarDareRequest, Types } from './types';
import { disponibilzarDareSuccess, disponibilzarDareFailure } from './actions';

function* disponibilzarDareRequest(request: ReducerActionRotaSP) {
	const { payload }: { payload: DisponibilzarDareRequest } = request;

	const token: string = yield select(state => state.user.token.data);

	const response: ApiResponse = yield call(
		postApi as any,
		token || '',
		PATH_IIRGD_BU_PPT,
		'potencial',
		payload,
	);

	if (response.status === 200 || response.status === 201) {
		yield put(disponibilzarDareSuccess(response));
	} else if (response.error) {
		yield put(disponibilzarDareFailure(response.message));
	}
}

export default all([
	takeLatest(Types.DISPONIBILIZAR_DARE_REQUEST, disponibilzarDareRequest),
]);
